// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export const MetlService = {
    // FullSyncLocation will trigger a full sync for the location provided in the location-id header
    FullSyncLocation(fn, _req) {
        return fn(`/messaging/etl/v1/full-sync-location`, { method: "POST" });
    },
};
